<template lang="pug">
  .wrap
    TransitionHero(:text="text")
</template>
<script>
import TransitionHero from '@/components/transition/TransitionHero'
export default {
  props: {
    text: String,
    bgimage: String
  },
  components: {
    TransitionHero
  }
}
</script>
<style lang="scss" scoped>
  .wrap{
    overflow: visible;
  }
  .bgimage{
    width: 100%;
    height: 100%;
    filter: grayscale(100);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
</style>